import { formatCurrency, toSecondaryUnitPrice } from "@heartinz/finance";
import CurrencyConverter from "@heartinz/currency_subunit_converter";

export function formatCurrencyFun(value) {
  return formatCurrency(
    CurrencyConverter.toCurrency(value || 0, "INR"),
    "INR",
    true,
    true,
    "en"
  );
}

export function formatCurrencyFunWithoutConvert(value) {
  return formatCurrency(value, "INR", true, true, "en");
}

export function getDisplayPrices(item) {
  if (!item?.unitConfig || !item?.isSecondaryUnit) {
    // Primary unit or no unit — show original
    return {
      mrp: CurrencyConverter.toCurrency(item?.mrp || 0, "INR"),
      saleprice: CurrencyConverter.toCurrency(item?.saleprice || 0, "INR"),
      discount: CurrencyConverter.toCurrency(item?.discount || 0, "INR"),
      lineTotalMrp:CurrencyConverter.toCurrency(
        item?.lineTotalMrp || 0,
        "INR"
      ),
    lineTotalDisc:CurrencyConverter.toCurrency(
        item?.lineTotalDiscount || 0,
        "INR"
      ),
    lineTotalSalePrice:CurrencyConverter.toCurrency(
        item?.lineTotalSalePrice || 0,
        "INR"
      ),
    };
  }

  // Secondary unit — convert prices for display only
  const value = toSecondaryUnitPrice(
    Number(item?.mrp || 0),
    Number(item?.saleprice || 0),
    Number(item?.baseprice || 0),
    item?.taxpercentage,
    item?.quantity,
    item?.isLock,
    item?.unitConfig
  );

  return {
    mrp: CurrencyConverter.toCurrency(
      value?.secondaryUnitPrice?.mrp || 0,
      "INR"
    ),
    saleprice: CurrencyConverter.toCurrency(
      value?.secondaryUnitPrice?.salePrice || 0,
      "INR"
    ),
    discount: CurrencyConverter.toCurrency(
      value?.secondaryUnitPrice?.discount || 0,
      "INR"
    ),
    lineTotalMrp:CurrencyConverter.toCurrency(
        value?.secondaryUnitPrice?.lineTotalMrp || 0,
        "INR"
      ),
    lineTotalDisc:CurrencyConverter.toCurrency(
        value?.secondaryUnitPrice?.lineTotalDiscount || 0,
        "INR"
      ),
    lineTotalSalePrice:CurrencyConverter.toCurrency(
        value?.secondaryUnitPrice?.lineTotalSalePrice || 0,
        "INR"
      ),
  };
}
